import ComponentOutlet from '../storyblok/ComponentOutlet';

function Conditional({ body }) {
	return <ComponentOutlet components={body} />;
}
export default Conditional;
